/**
 * Annual-subscription sales window: the only period when the renewal
 * buttons ("Поновити" / "Продовжити") are shown in the cabinet.
 *
 * Temporary, frontend-only measure until the renewal node is rebuilt
 * (the button will then be driven by the backend). Kyiv is UTC+2 in
 * December, so 07.12 00:00 Kyiv = 06.12 22:00 UTC.
 * Mirrors profile-new src/lib/renewalWindow.js — keep both in sync.
 */
export const RENEWAL_WINDOW = Object.freeze({
	from: Date.UTC(2026, 11, 6, 22, 0, 0), // 07.12.2026 00:00 Kyiv
	to: Date.UTC(2026, 11, 27, 22, 0, 0), // 28.12.2026 00:00 Kyiv, exclusive
});

/**
 * @param {number} [now] epoch ms, defaults to the current time
 * @returns {boolean}
 */
export function isRenewalWindowOpen(now = Date.now()) {
	return now >= RENEWAL_WINDOW.from && now < RENEWAL_WINDOW.to;
}
